'use strict';

var React = require('react/addons');
var CodeSnippet = require('./code-snippet');

var Install = React.createClass({
  displayName: 'Install',

  render: function render() {
    return React.createElement(
      'div',
      { className: 'install' },
      React.createElement(
        'h2',
        null,
        'Install'
      ),
      React.createElement(
        CodeSnippet,
        { language: 'bash', toggle: false },
        'npm install react-choice'
      )
    );
  }
});

module.exports = Install;


/*****************
 ** WEBPACK FOOTER
 ** ./example/components/install.jsx
 ** module id = 7
 ** module chunks = 0
 **/